
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetonagpurinnovacrystacarrental() {



    const cardData =
    {
        keyword: 'Pune to Nagpur Innova Crysta Car Rental',
        heading: 'Meghana Cab : Pune to Nagpur Innova Crysta Car Rental',
        headingDescription: 'Meghana Cab offers Pune to Nagpur Innova Crysta Car Rental, delivering a premium, comfortable, and reliable long-distance travel experience over the approximately 760 km journey (about 10–11 hours via the Mumbai–Pune Expressway and NH‑44). Our spacious Innova Crysta vehicles feature plush leather interiors, ample legroom, air-conditioning, and generous luggage capacity—ideal for families, group outings, or business travel. With professional chauffeurs familiar with the Pune–Nagpur route, door-to-door pickups from anywhere in Pune, GPS-enabled vehicles, and 24/7 customer support, Meghana Cab ensures your trip is safe, smooth, and tailored to your needs. Book your Pune to Nagpur Innova Crysta Cab with Meghana Cab and enjoy a stress-free, stylish travel experience from doorstep to destination.',


        top: 'Top Places to Visit in Nagpur with Meghana Cab',

"topPlaces": [
  {
    "title": "Deekshabhoomi (Dhamma Chakra Stupa)",
    "description": "A world‑renowned Navayana Buddhist monument where Dr B R Ambedkar embraced Buddhism in 1956. This grand hemispherical stupa—India's largest hollow stupa—attracts millions annually during Dhamma Chakra Pravartan Din. It’s a symbol of social reform, equality, and spiritual awakening, featuring Bodhi trees from ancient lineage and a serene meditation hall."  
  },
  {
    "title": "Sitabuldi Fort",
    "description": "A historic hill‑fort in central Nagpur, site of the pivotal 1817 Battle of Sitabuldi. Built in sandstone and basalt, it served under British rule and later housed Indian Army units. Open to the public on select national holidays, the fort offers panoramic cityscapes and compelling military architecture."  
  },
  {
    "title": "Zero Mile Stone",
    "description": "Erected during the Great Trigonometrical Survey in 1907, this sandstone pillar marks the geographic center of colonial India, where all distance measurements converged. Surrounded by stucco horses, it’s an intriguing colonial relic in Civil Lines with deep cartographic significance."  
  },
  {
    "title": "Raman Science Centre & Planetarium",
    "description": "A hands‑on science museum and planetarium named after Nobel Laureate C V Raman. Featuring interactive galleries, the Innovation Hub, science films, celestial shows, and a prehistoric park, it captivates school groups and curious minds with over 14 million visitors to date."  
  },
  {
    "title": "Futala & Ambazari Lakes",
    "description": "Two iconic Bhonsle‑era lakes within city limits: Futala Lake (60 acres) is known for colourful fountains, evening carriage rides, and forested shores, while Ambazari Lake—Nagpur’s largest—is surrounded by mango orchards and a landscaped garden, ideal for morning walks and picnics."  
  },
  {
    "title": "Dragon Palace Buddhist Temple",
    "description": "Also known as the Lotus Temple, this Indo‑Japanese Buddhist temple located in Kamptee exudes tranquility. Built in 1999, it features a carved sandalwood Buddha, manicured gardens, and a meditative ambiance inspired by Japanese design."  
  },
  {
    "title": "Ramtek Fort Temple",
    "description": "Perched on a hill outside Nagpur, this mythological site is said to be where Lord Rama paused during his exile. Set within a small fort, the temple offers spiritual significance, panoramic valley views, and a serene escape from the city."  
  },
  {
    "title": "Tekdi Ganesh Mandir",
    "description": "Popularly known as 'Tekdi Cha Ganpati', this 250‑year‑old Ganesha temple sits atop Sitabuldi Tekdi hill. The self-manifested idol was uncovered while blasting the hill for railway tracks in 1875, and today the temple is a vibrant pilgrimage spot overlooking the city."  
  },
  {
    "title": "Waki Woods & Gorewada Lake",
    "description": "Nature-lovers’ retreats: Waki Woods—30 km from Nagpur—offers lush greenery perfect for picnics and hikes, while nearby Gorewada Lake and safari zones are ideal for day outings amidst rich flora and fauna."  
  },
  {
    "title": "Ambazari & Futala Evening Promenades",
    "description": "Both lakes transform in the evening: Futala’s illuminated fountains and carriage rides create a vibrant atmosphere, while Ambazari Garden attracts walkers and couples with its greenery and calm ambiance."  
  }
],

  "services": [
    {
      "name": "Pune to Nagpur Innova Crysta Cab Booking",
      "description": "Book a premium Innova Crysta cab for your journey from Pune to Nagpur. Enjoy a comfortable ride with ample space, modern amenities, and professional chauffeur service, making your long-distance travel relaxing and hassle-free."
    },
    {
      "name": "One Way Innova Crysta Pune Nagpur",
      "description": "Opt for our one-way Innova Crysta cab service from Pune to Nagpur, ideal for travelers who need a convenient, affordable, and reliable transfer without the worry of return trips."
    },
    {
      "name": "Round Trip Innova Crysta Pune Nagpur",
      "description": "Choose our round trip service for flexible and stress-free travel between Pune and Nagpur. Benefit from a single vehicle and driver for both onward and return journeys with easy scheduling."
    },
    {
      "name": "AC Innova Crysta Taxi Pune Nagpur",
      "description": "Travel in comfort with our fully air-conditioned Innova Crysta taxis from Pune to Nagpur. Stay cool and refreshed throughout the journey, no matter the season or weather conditions."
    },
    {
      "name": "Chauffeur Driven Innova Crysta Pune Nagpur",
      "description": "Experience a safe and smooth ride with our courteous and experienced chauffeurs. They are knowledgeable about the Pune to Nagpur route and committed to providing you with a pleasant journey."
    },
    {
      "name": "Private Innova Crysta Taxi Pune Nagpur",
      "description": "Enjoy privacy and flexibility with a private Innova Crysta taxi exclusively reserved for you. Perfect for family trips, corporate travel, or group outings to Nagpur."
    },
    {
      "name": "Online Booking Innova Crysta Pune Nagpur",
      "description": "Easily book your Pune to Nagpur Innova Crysta cab online with real-time availability, upfront pricing, and instant confirmation. Plan your trip conveniently from anywhere."
    },
    {
      "name": "Nagpur Tour Innova Crysta",
      "description": "Extend your journey with local tours around Nagpur. Explore popular attractions, historical sites, and local culture with a comfortable Innova Crysta cab at your disposal."
    },
    {
      "name": "Business Travel Innova Crysta Nagpur",
      "description": "Ideal for corporate travelers, our business travel Innova Crysta service offers punctuality, comfort, and professionalism to help you reach your meetings and events on time and relaxed."
    },
    {
      "name": "Comfortable Innova Crysta Taxi Pune Nagpur",
      "description": "Enjoy a smooth and comfortable ride in our Innova Crysta taxis designed for long-distance travel. Spacious interiors, reclining seats, and noise reduction features ensure a restful trip."
    },
    {
      "name": "Budget Innova Crysta Cab Pune Nagpur",
      "description": "Travel affordably without compromising comfort. Our budget-friendly Innova Crysta cabs provide great value for money on your Pune to Nagpur journey."
    },
    {
      "name": "Reliable Innova Crysta Taxi Nagpur",
      "description": "Count on our reliable service for timely pickups, well-maintained vehicles, and professional drivers. We prioritize your safety and convenience on every trip."
    },
    {
      "name": "Family Travel Innova Crysta Nagpur",
      "description": "Perfect for family trips, our Innova Crysta offers spacious seating, luggage space, and amenities to ensure a pleasant and enjoyable travel experience for all family members."
    },
    {
      "name": "Long Distance Innova Crysta Rental",
      "description": "Our Innova Crysta is well-equipped for long-distance rentals, offering durability, comfort, and safety features essential for extended journeys like Pune to Nagpur."
    },
    {
      "name": "Premium Innova Crysta Hire Nagpur",
      "description": "For those seeking luxury and exclusivity, our premium Innova Crysta hire provides leather interiors, captain seats, and VIP service, perfect for executives and special occasions."
    }
  ],
  "tableData": [
    ["Pune to Nagpur Innova Crysta Cab Booking", "One Way Innova Crysta Pune Nagpur"],
    ["Round Trip Innova Crysta Pune Nagpur", "AC Innova Crysta Taxi Pune Nagpur"],
    ["Chauffeur Driven Innova Crysta Pune Nagpur", "Private Innova Crysta Taxi Pune Nagpur"],
    ["Online Booking Innova Crysta Pune Nagpur", "Nagpur Tour Innova Crysta"],
    ["Business Travel Innova Crysta Nagpur", "Comfortable Innova Crysta Taxi Pune Nagpur"],
    ["Budget Innova Crysta Cab Pune Nagpur", "Reliable Innova Crysta Taxi Nagpur"],
    ["Family Travel Innova Crysta Nagpur", "Long Distance Innova Crysta Rental"],
    ["Premium Innova Crysta Hire Nagpur", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Premium Innova Crysta Car Rental from Pune to Nagpur",
    "WhyChoosedescription": "Travel from Pune to Nagpur in comfort and style with our Innova Crysta car rental service. Whether for a family visit, corporate meeting, or personal travel, our long-distance cab service offers luxury and reliability for the 720+ km journey."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable for Long Highway Journeys",
    "WhyChoosedescription": "The Innova Crysta offers ample legroom, reclining seats, dual AC, and large boot space—perfect for group or family travel. With capacity for up to 6–7 passengers, enjoy a stress-free ride to Nagpur without compromising comfort."
  },
  {
    "WhyChooseheading": "Experienced and Courteous Drivers",
    "WhyChoosedescription": "Our drivers are professionally trained for long-distance travel and well-versed with Pune–Aurangabad–Nagpur routes. They ensure safe driving, punctuality, and can assist with route breaks and travel coordination."
  },
  {
    "WhyChooseheading": "Sanitized and Well-Maintained Vehicles",
    "WhyChoosedescription": "All vehicles are deep cleaned and sanitized before every trip. Regular mechanical checks ensure a smooth and reliable journey, especially over extended highway routes like Pune to Nagpur."
  },
  {
    "WhyChooseheading": "Flexible Booking – One-Way or Round Trip",
    "WhyChoosedescription": "Choose between one-way rentals, round trips, or multi-day packages based on your travel needs. Customize pickup and drop locations and add planned halts or overnight stays en route if required."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Costs",
    "WhyChoosedescription": "Our fare includes fuel, tolls, driver allowance, and all applicable taxes. You get clear pricing upfront—no surprises at the end of the trip."
  },
  {
    "WhyChooseheading": "Ideal for Business Travel, Family Visits, or Relocation",
    "WhyChoosedescription": "Whether you're relocating to Nagpur, heading for a business assignment, or visiting family, our Innova Crysta offers the space, comfort, and reliability needed for such long-haul journeys."
  },
  {
    "WhyChooseheading": "24/7 Customer Support and Easy Online Booking",
    "WhyChoosedescription": "Get assistance anytime with booking, rescheduling, or route customization. Our dedicated team is available around the clock to ensure your Pune to Nagpur travel experience is smooth and well-coordinated."
  }
]






















    }

const faqData = [
    {
        question: "How can I book an Innova Crysta from Pune to Nagpur?",
        answer: "You can book by calling Meghana Cab at +91 9075462128 or through our website for easy and quick booking."
    },
    {
        question: "What is the distance and estimated travel time from Pune to Nagpur?",
        answer: "The distance is approximately 840 km, with a travel time of around 14 to 16 hours depending on traffic and route."
    },
    {
        question: "Is the Innova Crysta suitable for a long trip to Nagpur?",
        answer: "Yes, the Innova Crysta is spacious, comfortable, and perfect for long-distance journeys like Pune to Nagpur."
    },
    {
        question: "Can I book a one-way or round-trip service for Pune to Nagpur?",
        answer: "Yes, Meghana Cab offers both one-way and round-trip rental options for your convenience."
    },
    {
        question: "How many passengers can the Innova Crysta accommodate?",
        answer: "The Innova Crysta can comfortably seat 6 to 7 passengers with ample space for luggage."
    },
    {
        question: "Are your vehicles sanitized before every trip?",
        answer: "Yes, we ensure all vehicles are thoroughly sanitized before each journey for passenger safety."
    },
    {
        question: "What is included in the rental fare for Pune to Nagpur?",
        answer: "The fare includes fuel, driver charges, and tolls. Extra waiting time or parking fees may incur additional costs."
    },
    {
        question: "Can I request stops for meals or sightseeing on the way to Nagpur?",
        answer: "Yes, stops can be arranged on request. Please inform us while booking."
    },
    {
        question: "Are the drivers experienced with the Pune to Nagpur route?",
        answer: "Yes, our drivers are skilled and familiar with the route, ensuring a safe and comfortable trip."
    },
    {
        question: "What payment methods are accepted for this car rental?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Suresh Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The Innova Crysta was perfect for our Pune to Nagpur trip. Comfortable seating and a professional driver made the journey hassle-free.”',
    },
    {
        name: 'Ms. Anjali Patil',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Highly satisfied with Meghana Cab’s service. The car was clean and the driver courteous throughout our Pune-Nagpur travel.”',
    },
];
































































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];









const puneNagpurInnovaSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Nagpur Innova Crysta Car Rental",
  "description": "Book chauffeur-driven Innova Crysta from Pune to Nagpur for family travel, business trips, or long-distance tours. Comfortable, AC cabs with reliable service and online booking.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Outstation Taxi Service",
  "areaServed": {
    "@type": "Place",
    "name": "Pune to Nagpur"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-nagpur-innova-crysta-cab"
  }
};







    return (
        <div>

<Helmet>
  <title>Pune to Nagpur Innova Crysta Cab | Car Rental Booking</title>
  <meta
    name="description"
    content="Rent Innova Crysta cab from Pune to Nagpur for business or family trips. Chauffeur-driven, AC, comfortable cars with budget-friendly pricing and online booking available."
  />
  <meta
    name="keywords"
    content="Pune to Nagpur Innova Crysta Cab Booking, One Way Innova Crysta Pune Nagpur, Round Trip Innova Crysta Pune Nagpur, AC Innova Crysta Taxi Pune Nagpur, Chauffeur Driven Innova Crysta Pune Nagpur, Private Innova Crysta Taxi Pune Nagpur, Online Booking Innova Crysta Pune Nagpur, Nagpur Tour Innova Crysta, Business Travel Innova Crysta Nagpur, Comfortable Innova Crysta Taxi Pune Nagpur, Budget Innova Crysta Cab Pune Nagpur, Reliable Innova Crysta Taxi Nagpur, Family Travel Innova Crysta Nagpur, Long Distance Innova Crysta Rental, Premium Innova Crysta Hire Nagpur"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneNagpurInnovaSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/11.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetonagpurinnovacrystacarrental;